#import "../fragments/managed-meeting-fragment.graphql"

mutation UpdateManagedMeetingTemplateAssignments(
    $input: ManagedMeetingTemplateAssignmentsUpdateInput!
) {
    managedMeetingTemplateAssignmentsUpdate(input: $input) {
        meeting {
            ...ManagedMeetingFragment
        }
    }
}
